var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("div", { staticClass: "d2-mb" }, [_vm._v("Cookie 读写")]),
          _c("el-alert", {
            attrs: {
              title: "建议",
              type: "warning",
              description:
                "建议使用 util 内的 cookies 对象，这样会在存储和读取时统一增加前缀，方便对 cookie 统一管理",
              "show-icon": ""
            }
          })
        ],
        1
      ),
      _c("p", { staticClass: "d2-mt-0" }, [_vm._v("基本读写删")]),
      _c(
        "el-button",
        {
          attrs: { type: "primary" },
          on: {
            click: function($event) {
              return _vm.set("demo-user-name", "demo-user")
            }
          }
        },
        [_vm._v("set('demo-user-name', 'normalValue')")]
      ),
      _c(
        "el-button",
        {
          attrs: { type: "info" },
          on: {
            click: function($event) {
              return _vm.get("demo-user-name")
            }
          }
        },
        [_vm._v("get('demo-user-name')")]
      ),
      _c(
        "el-button",
        {
          attrs: { type: "error" },
          on: {
            click: function($event) {
              return _vm.remove("demo-user-name")
            }
          }
        },
        [_vm._v("remove('demo-user-name')")]
      ),
      _c("p", [_vm._v("设置有效期")]),
      _c(
        "el-button",
        {
          attrs: { type: "primary" },
          on: {
            click: function($event) {
              return _vm.setExpires("demo-user-pwd", "123456789", 1)
            }
          }
        },
        [_vm._v("设置 'demo-user-pwd' 有效期为一天")]
      ),
      _c(
        "el-button",
        {
          attrs: { type: "info" },
          on: {
            click: function($event) {
              return _vm.get("demo-user-pwd")
            }
          }
        },
        [_vm._v("get('demo-user-pwd')")]
      ),
      _c(
        "el-button",
        {
          attrs: { type: "error" },
          on: {
            click: function($event) {
              return _vm.remove("demo-user-pwd")
            }
          }
        },
        [_vm._v("remove('demo-user-pwd')")]
      ),
      _c("p", [_vm._v("获取所有可以获得的数据")]),
      _c("el-button", { attrs: { type: "info" }, on: { click: _vm.getAll } }, [
        _vm._v("getAll")
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }